module.exports = __webpack_public_path__ + "img/chargeBanner.e173ca6d.png";